import { useEffect } from "react";
import Rodal from "rodal";
import { TailSpin } from "react-loader-spinner";
import { getThemeColor } from "../../utils/constants";

export default function LoadingModal({ theme }) {
  useEffect(() => {
    document.body.classList.add("position-fixed");
    return () => document.body.classList.remove("position-fixed");
  }, []);

  return (
    <Rodal
      visible={true}
      onClose={() => {}}
      showCloseButton={false}
      customStyles={{
        padding: 16,
        width: "max-content",
        maxWidth: "20rem",
        height: "max-content",
        maxHeight: "40rem",
        overflowY: "auto",
      }}
      customMaskStyles={{
        backgroundColor: "rgba(0, 0, 0, .7)",
      }}
      animation="fade">
      <div className="custom-modal-container">
        <TailSpin
          ariaLabel="loading-indicator"
          height={24}
          width={24}
          color={getThemeColor(theme).backgroundColor}
        />
      </div>
    </Rodal>
  );
}
